import { mapGetters } from 'vuex';
import { resolveAppShell } from '@/shells/shellResolver';
import { interfacePreferencesController } from '@/shells/services/interfacePreferencesController';
import { availableExperience, explicitContentExperience } from './models/contentExperience';

// Keep presentation separate from route layout: an unported page can still be
// visited within the modern experience. Do not unmount its menu on an optimistic
// preference write; the menu announces successful switches explicitly.
export default {
  data: () => ({ navigationExperience: 'legacy', navigationRevision: 0 }),
  computed: {
    ...mapGetters(['_g_User', '_g_UserId']),
    navigationAccountKey() { return `${this._g_UserId || 0}:${availableExperience('modern', this._g_User)}`; },
    useIncrementalNavigation() {
      if (resolveAppShell(this.$route) === 'bare') return false;
      const experience = explicitContentExperience(this.$route)
        || (resolveAppShell(this.$route) === 'modern' ? 'modern' : this.navigationExperience);
      return availableExperience(experience, this._g_User) === 'modern';
    }
  },
  watch: {
    '$route': { immediate: true, handler(route) {
      const experience = explicitContentExperience(route);
      if (experience) this.setNavigationExperience(experience);
    } },
    navigationAccountKey: { immediate: true, async handler() {
      const revision = ++this.navigationRevision;
      const uid = this._g_UserId;
      const state = interfacePreferencesController.stateFor(uid);
      const routeExperience = explicitContentExperience(this.$route);
      this.navigationExperience = routeExperience || state.preferences.shell;
      if (!uid || availableExperience('modern', this._g_User) !== 'modern') return;
      try {
        const preferences = await interfacePreferencesController.load(uid);
        if (revision === this.navigationRevision) this.navigationExperience = explicitContentExperience(this.$route) || routeExperience || preferences.shell;
      } catch (_) { /* Preserve the current/cached experience on network failure. */ }
    } }
  },
  beforeDestroy() { this.navigationRevision++; },
  methods: {
    setNavigationExperience(experience) {
      this.navigationRevision++;
      this.navigationExperience = experience;
    }
  }
};
